import React, { useEffect, useState } from "react";
import cx from "classnames";
import Image from "../../Image";
import image from "../../Results/LoadingInterstitial/imgs/loading.gif";
import t from "../../../utils/translate";

import styles from "./styles.module.scss";

export default function LoadingInterstitial() {
  const [visible, setVisible] = useState(true);
  const [elementVisible, setElementVisible] = useState(true);
  const delay = 2500;

  useEffect(() => {
    setTimeout(() => {
      setVisible(false);

      setTimeout(() => {
        setElementVisible(false);
      }, 600);
    }, delay);
  }, [delay]);

  return (
    <>
      {elementVisible && (
        <div
          className={cx(styles.container, {
            [styles.hidden]: !visible
          })}
        >
          <div className={styles.inner}>
            <Image className={styles.image} src={image} alt="" />
            <div className={styles.subheader}>{t("RECIPES_LOADING")}</div>
          </div>
        </div>
      )}
    </>
  );
}
